import React from 'react';
export function Footer() {
  return <footer className="bg-cream-dark/20 py-12 text-center" data-id="element-74">
      <div className="max-w-4xl mx-auto px-6" data-id="element-75">
        <h2 className="font-serif text-2xl tracking-widest text-brown-dark mb-6 uppercase" data-id="element-76">
          Renacida
        </h2>

        <div className="flex items-center justify-center gap-4 mb-8" data-id="element-77">
          <div className="w-12 h-px bg-rose/30" data-id="element-78"></div>
          <span className="text-rose-light" data-id="element-79">♡</span>
          <div className="w-12 h-px bg-rose/30" data-id="element-80"></div>
        </div>

        <p className="text-sm text-brown-light" data-id="element-81">
          © {new Date().getFullYear()} Renacida. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}